module.exports = __webpack_public_path__ + "resources/errorPageImageApple_ab1e33ee0c.png";